import React from 'react';

const InvestmentAndDeclaration = ({
    formData,
    handleInputChange,
    handleDateChange,
    errors
}) => {
    return (
        <>
            <div className="form-section">
                <h3 className="section-heading">Investment History, Horizon & Risk Appetite & preferences</h3>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label className="form-label">Investing Experience:</label>
                            <select
                                name="investing_experience"
                                value={formData.investing_experience}
                                onChange={handleInputChange}
                                className="form-input"
                            >
                                <option value="">Select Experience</option>
                                <option value="< 1 year">&lt; 1 year</option>
                                <option value="1 - 5 years">1 - 5 years</option>
                                <option value="5 - 15 years">5 - 15 years</option>
                                <option value="> 15 years">&gt; 15 years</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label className="form-label">Time Horizon:</label>
                            <select
                                name="time_horizon"
                                value={formData.time_horizon}
                                onChange={handleInputChange}
                                className="form-input"
                            >
                                <option value="">Select Time Horizon</option>
                                <option value="< 1 year">&lt; 1 year</option>
                                <option value="1 - 3 years">1 - 3 years</option>
                                <option value="3 - 5 years">3 - 5 years</option>
                                <option value="> 5 years">&gt; 5 years</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label className="form-label">Risk Appetite:</label>
                            <select
                                name="risk_appetite"
                                value={formData.risk_appetite}
                                onChange={handleInputChange}
                                className="form-input"
                            >
                                <option value="">Select Risk Appetite</option>
                                <option value="No Risk">No Risk</option>
                                <option value="Low Risk">Low Risk</option>
                                <option value="Moderate Risk">Moderate Risk</option>
                                <option value="High Risk">High Risk</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label className="form-label">Scale:</label>
                            <select
                                name="scale"
                                value={formData.scale}
                                onChange={handleInputChange}
                                className="form-input"
                            >
                                <option value="">Select Scale</option>
                                <option value="Up to 1 Crore">up to 1 crore</option>
                                <option value="1 - 5 Crore">1-5 Crore</option>
                                <option value="6 - 15 Crore">6 to 15 Crore</option>
                                <option value="16 - 45 Crore">16-45 Crore</option>
                                <option value="> 45 Crore">&gt; 45 Crore</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label className="form-label">Open for any Joint Investment:</label>
                            <select
                                name="open_for_any_joint_investment"
                                value={formData.open_for_any_joint_investment}
                                onChange={handleInputChange}
                                className="form-input"
                            >
                                <option value="">Select Option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {/* Declaration */}
            <div className="form-section">
                <h3 className="section-heading">Declaration</h3>
                <div className="declaration-box checkbox-group-vertical">
                    <div className="checkbox-item mb-3 d-flex align-items-start">
                        <input
                            type="checkbox"
                            id="decl1"
                            name="declaration_1"
                            checked={formData.declaration_1}
                            onChange={handleInputChange}
                            className={`form-checkbox ${errors.declaration_1 ? 'error' : ''}`}
                        />
                        <label htmlFor="decl1" className="ms-2">I hereby declare that I have read, been explained and understood all terms and conditions.</label>
                    </div>
                    {errors.declaration_1 && <span className="error-message mb-3 ms-4 mt-0">{errors.declaration_1}</span>}

                    <div className="checkbox-item mb-3 d-flex align-items-start">
                        <input
                            type="checkbox"
                            id="decl2"
                            name="declaration_2"
                            checked={formData.declaration_2}
                            onChange={handleInputChange}
                            className={`form-checkbox ${errors.declaration_2 ? 'error' : ''}`}
                        />
                        <label htmlFor="decl2" className="ms-2">All investment decisions are made at my own discretion, and I accept that while opportunities may be rewarding, they also carry inherent risks. I am fully responsible for my investment choices and outcomes.</label>
                    </div>
                    {errors.declaration_2 && <span className="error-message mb-3 ms-4 mt-0">{errors.declaration_2}</span>}

                    <div className="checkbox-item mb-md-3 d-flex align-items-start">
                        <input
                            type="checkbox"
                            id="decl3"
                            name="declaration_3"
                            checked={formData.declaration_3}
                            onChange={handleInputChange}
                            className={`form-checkbox ${errors.declaration_3 ? 'error' : ''}`}
                        />
                        <label htmlFor="decl3" className="ms-2">I understand that CBP's role is to facilitate access to investment opportunities and that it does not offer any guarantees or assurances regarding returns.</label>
                    </div>
                    {errors.declaration_3 && <span className="error-message mb-3 ms-4 mt-0">{errors.declaration_3}</span>}
                </div>

                {/* Hidden inputs to maintain state structure as requested */}
                <input type="hidden" name="name_signature" value={formData.name_signature || ''} />
                <input type="hidden" name="sign" value={formData.sign || ''} />
                <input type="hidden" name="date" value={formData.date || ''} />
                <input type="hidden" name="place" value={formData.place || ''} />
            </div>

            {/* Fee Payment Section (Hidden) & CBP Use (Hidden) - maintained for payload structure */}
            <input type="hidden" name="instrument_no__rtgs_ref_no" value={formData.instrument_no__rtgs_ref_no || ''} />
            <input type="hidden" name="fee_date" value={formData.fee_date || ''} />
            <input type="hidden" name="amount_in_words" value={formData.amount_in_words || ''} />

            <input type="hidden" name="approved_by" value={formData.approved_by || ''} />
            <input type="hidden" name="approved_date" value={formData.approved_date || ''} />
            <input type="hidden" name="membership_number" value={formData.membership_number || ''} />
            <input type="hidden" name="approver_sign" value={formData.approver_sign || ''} />
        </>
    );
};

export default InvestmentAndDeclaration;
